import { render } from "./TheTemplateI.vue?vue&type=template&id=60aa41f8&scoped=true&ts=true"
import script from "./TheTemplateI.vue?vue&type=script&lang=ts"
export * from "./TheTemplateI.vue?vue&type=script&lang=ts"

import "./TheTemplateI.vue?vue&type=style&index=0&id=60aa41f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60aa41f8"]])

export default __exports__